import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import { validateRenderConditions } from 'functions/replaceTextShortCodes'

import ToggleableSection from 'agency/digital_renderer/components/ToggleableSection'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import ContentHolder from '../../../ui/ContentHolder'
import ElementContainer from '../../ElementContainer'
import styles from './styles.scss'

const wrapContent = (disableContentHolder, contentWidthId, children) => {
  if (disableContentHolder) return children

  return <ContentHolder contentWidthId={contentWidthId}>{children}</ContentHolder>
}

const Section = (props) => {
  const { callbacks, section } = props

  const options = section.options || {}
  const {
    anchor, contentWidthId, disableContentHolder, renderConditions, toggleable,
  } = options

  const defaultContext = useContext(GlobalContext)

  const shouldRender = validateRenderConditions(renderConditions, defaultContext)

  if (!shouldRender) return null

  return (
    <ElementContainer
      callbacks={callbacks}
      section={section}
      renderNested
      render={({ itemComponents }) => (
        <ToggleableSection isToggleable={toggleable} sectionId={section.id}>
          <div id={anchor} className={styles.root} style={deviceStyle(section)}>
            {wrapContent(disableContentHolder, contentWidthId, itemComponents.map(component => component))}
          </div>
        </ToggleableSection>
      )}
    />
  )
}

Section.propTypes = {
  callbacks: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
}

export default Section
